export default function reducerCustomers(state = {}, action) {
  switch (action.type) {
    case 'GET_TOP_PRODUCTS':
      return {
        ...state,
        topProducts: action.payload.data,
      }
    default:
      return state
  }
}
